import { FunctionComponent } from 'react';

import { Icon } from '@kanda-libs/ks-design-library';

import OpenBankingSatNoteModal from './Modal';
import useOpenBankingSatNoteModalButton from './useOpenBankingSatNoteModalButton';

const OpenBankingSatNoteModalButton: FunctionComponent = () => {
  const { onClick } = useOpenBankingSatNoteModalButton();
  return (
    <div className="w-full">
      <p className="text-14-22-em text-neutral-700 mb-3">Todo</p>
      <button
        onClick={onClick}
        type="button"
        className="flex flex-row w-full p-3 justify-between border border-neutral-300 shadow-card rounded-xl"
      >
        <div className="flex flex-row">
          <div className="rounded-full p-1 bg-lavender-200 mb-auto mt-1.5 mr-2" />
          <div className="flex flex-col text-left">
            <p className="text-14-22-em text-lavender-300">
              Sign your satisfaction note
            </p>
            <p className="text-12-18 text-neutral-600">
              Please answer some questions and sign your satisfaction note
            </p>
          </div>
        </div>
        <Icon
          icon="chevron-right"
          size={16}
          className="my-auto ml-3"
          stroke="neutral-600"
        />
      </button>
      <OpenBankingSatNoteModal />
    </div>
  );
};

export default OpenBankingSatNoteModalButton;
